import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EMAIL_RECIPIENTS_BY_COUNTRY } from '@core/config/email-recipients-by-country';


@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private apiUrl = `${environment.host}/send-email`; // Change this based on your backend URL

  constructor(private http: HttpClient) {}

  public sendEmail(to: string, subject: string, text: string): Observable<any> {
   
    return this.http.post(this.apiUrl, { to, subject, text });
  }
  
  public getEmailRecipientsByCountry(countryCode: string): string {
    const targetKey = Object.keys(EMAIL_RECIPIENTS_BY_COUNTRY).find(countryCodes => {
      return countryCodes.includes(countryCode);
    });

    return EMAIL_RECIPIENTS_BY_COUNTRY[targetKey]?.join(',') ?? EMAIL_RECIPIENTS_BY_COUNTRY['OTHER']?.join(',');
  }
}
